import Ajv from 'ajv';

/**
 * Get the errors produced from ajv in the format react-hook-forms
 * understands.
 * @param ajv
 * @returns
 */
export const getAjvErrorsForReactHookForms = (ajv: Ajv) => {
	const errorsFormatted = ajv.errors?.reduce(
		(prev, current) => ({
			...prev,
			[current.instancePath.replace('/', '')]: {
				type: current.keyword ?? 'validation',
				message: current.message,
			},
		}),
		{}
	);

	return {
		values: {},
		errors: errorsFormatted,
	};
};
